"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "scisciano": {
    "5367cbe1": [{
      "hkey": "a9b21273",
      "slug": "scisciano",
      "name": "Scisciano",
      "primary": true,
      "skipSearch": false
    }],
    "frocia": [{
      "hkey": "a9b21273",
      "slug": "scisciano",
      "name": "Scisciano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a45d8eee": [{
      "hkey": "a9b21273",
      "slug": "scisciano",
      "name": "Scisciano",
      "primary": true,
      "skipSearch": false
    }],
    "palazzuolo": [{
      "hkey": "a9b21273",
      "slug": "scisciano",
      "name": "Scisciano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "97bd34f9": [{
      "hkey": "eff21b89",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "san-martino": [{
      "hkey": "eff21b89",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "scisciano"
    }]
  }
};
exports["default"] = _default;